import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters} from 'src/modules/entitlements/typedef';

export const updateUsersEntitlementsStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    EntitlementsFilters
>('updateUsersEntitlementsState');

export const updateUsersEntitlementsStateActions = updateUsersEntitlementsStateSlice.actions;
export const updateUsersEntitlementsStateSelector: CachedTableStateSelector<undefined, undefined, EntitlementsFilters> =
    state => state.accountPage.tabs.usersAndGroups.updateUsersEntitlementsState;
